module.exports = __webpack_public_path__ + "img/Menu-03.104d90d0.png";